import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../../../../../app/directives/shared.module';
import { c_card_arming_status_widget_component } from './c_card_arming_status_widget.component';
import { PartitionArmingModule } from '@app/modals/partition-arming/partition-arming.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    PartitionArmingModule
  ],
  declarations: [ c_card_arming_status_widget_component ],
  exports: [ c_card_arming_status_widget_component ],
})
export class c_card_arming_status_widget_module { }
